import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { login, formatApiErrorDetail } from "@/lib/api";

export default function Login() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen flex items-center justify-center px-6" data-testid="login-page">
      <motion.form
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        onSubmit={submit}
        className="w-full max-w-md border border-ink p-10 bg-paper"
      >
        <p className="font-mono-tech text-xs uppercase tracking-[0.25em] text-auroraDeep mb-4">Owner Access</p>
        <h1 className="font-display font-bold text-4xl mb-8">Sign in</h1>

        <label className="block font-mono-tech text-[11px] uppercase tracking-wider text-stone mb-2">Email</label>
        <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required className="w-full border border-line px-4 py-3 mb-5 bg-paper outline-none focus:border-ink transition-colors" data-testid="login-email" />

        <label className="block font-mono-tech text-[11px] uppercase tracking-wider text-stone mb-2">Password</label>
        <input value={password} onChange={(e) => setPassword(e.target.value)} type="password" required className="w-full border border-line px-4 py-3 mb-6 bg-paper outline-none focus:border-ink transition-colors" data-testid="login-password" />

        {error && <p className="text-red-500 text-sm mb-4" data-testid="login-error">{error}</p>}

        <button type="submit" disabled={loading} className="w-full bg-ink text-paper py-3.5 font-mono-tech text-xs uppercase tracking-[0.15em] hover:opacity-90 disabled:opacity-50 transition-opacity" data-testid="login-submit">
          {loading ? "Signing in..." : "Enter"}
        </button>
      </motion.form>
    </main>
  );
}
